export default __webpack_public_path__ + "img/jewson.png";